module.exports = __webpack_public_path__ + "img/pertare-post-mortem-logo.78993e8a.png";